import { Link } from "@StarberryUtils";
import React, { useEffect, useState, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import HTMLReactParser from 'html-react-parser';
import "../PropertyDetails/ProductInfo/ProductInfo.scss";
import { GetURL } from "../common/site/functions";
import ModalTiny from "react-bootstrap/Modal"
import { useLocation } from "@reach/router";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { PhoneIconBlue, EnvelopeIconBlue, WhatsAppIconBlue, CloseIcon } from "../Icons/Icons";
import CareerForm from "../forms/career-form";
import Form from "../forms/reach-us-form";
import _ from "lodash";
import './Sidebar.scss';

const CareerSidebar = (props) => {
	const location = useLocation();
    const data = useStaticQuery(graphql`
        query {
            glstrapi {
                globalModule {
                    Static_Page_Sidebar_Title
                    Static_Page_Sidebar_CTA_Label
                    Static_Page_Sidebar_Content
                    Static_Page_Sidebar_CTA_Link {
                        id
                    }
                    Opening_Hours
                }
            }
        }
    `);

    const content = data.glstrapi.globalModule;

    let url = '';
    if (content.Static_Page_Sidebar_CTA_Link) {
        url = GetURL(content.Static_Page_Sidebar_CTA_Link.id);
    }

    const [people, setPeople] = useState(null); // Manage the people state
    const [modalAskformOpen, setAskformOpen] = useState(false); // Modal state for opening/closing

    const openAskformModal = () => {
        setAskformOpen(true);
    };

    const closeAskformModal = () => {
        setAskformOpen(false);
    };


    const [modalApplyformOpen, setApplyformOpen] = React.useState(false);

	const openApplyformModal = () => {
		setApplyformOpen(true);
	}
	const closeApplyformModal = () => {
		setApplyformOpen(false);
	}


    // Retrieve contact details, prioritize from props.peoples[0], fallback to props.site
    const getPhoneNumber = () => {
       // return props?.peoples?.[0]?.Phone || props?.site?.Phone?.replace(/ /g, '').replace(/\+/g, '') || '+971 44 23 2006';
        return '+971 44 23 2006';
    };

    const getEmail = () => {
        return props?.peoples?.[0]?.Email || props?.site?.Email || 'info@dacha.ae';
    };

    const getWhatsApp = () => {
       // return props?.peoples?.[0]?.Phone?.replace(/ /g, '').replace(/\+/g, '') || props?.site?.Phone?.replace(/ /g, '').replace(/\+/g, '') || '971586234140';
        return '971586234140';
    };

    const phoneNumber = getPhoneNumber();
    const email = getEmail();
    const whatsappNumber = getWhatsApp();

	const location_link = `${process.env.GATSBY_SITE_URL}${location.pathname}`;
	const whatsapp_link = location.search.indexOf("utm_source") > 0 
		? `https://wa.me/${whatsappNumber}?text=*G*%20Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`
		: `https://wa.me/${whatsappNumber}?text=Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`;
    return (
        <React.Fragment>
            <div className={`static-page-sidebar-widget ${props.class} career-landing-sidebar`}>
                <div className="sidebar-top">
                    <h5 className="text-lg-bold-32-18">
                        {props?.sidebarWidget?.SidebarTitle || content?.Static_Page_Sidebar_Title || 'Join a driven, career-led estate agents team. What are you waiting for?'}
                    </h5>
                    <div className="text-sm sidebar-intro-content">
                        {HTMLReactParser(
                            (props?.sidebarWidget?.SidebarContent || content?.Static_Page_Sidebar_Content || "Speak to one of our recruiter's today for a personal touch.")
                                .replace(/<br\s*\/?>/gi, '')
                        )}
                    </div>
                </div>
                <div className="sidebar-contact-info">
                    <Link href={`tel:${phoneNumber}`} className="text-xxs btn btn-light-blue">
                        <span><PhoneIconBlue className="icon-contact-info" /></span><span>Call</span>
                    </Link>
				   <Link onClick={openApplyformModal} className="text-xxs btn btn-light-blue">
						<span><EnvelopeIconBlue className="icon-contact-info" /></span><span>Email</span>
					</Link> 
                   	{/* <Link href={"/about-dacha/careers/send-cv/"} className="text-xxs btn btn-light-blue">
						<span><EnvelopeIconBlue className="icon-contact-info" /></span><span>Email</span>
					</Link> */}
                    <Link href={whatsapp_link} className="text-xxs btn btn-light-blue" target="_blank">
                        <span><WhatsAppIconBlue className="icon-contact-info" /></span><span className="d-none d-md-flex">WhatsApp</span>
                    </Link>
                </div>
                <ModalTiny show={modalAskformOpen} onHide={closeAskformModal} className="modal-form-wrapper people-details-form-modal-main">
                <ModalTiny.Header>
                    <div class="modal-close-btn" onClick={closeAskformModal}><CloseIcon /></div>
                    <ModalTiny.Title><h4>
                                {people?.Name ? `Contact ${people.Name}` : 'Contact Dacha'}
                            </h4>
                        </ModalTiny.Title>
                    </ModalTiny.Header>
                    <ModalTiny.Body>
                        <Form peopleName={people?.Name || 'Dacha'} />
                    </ModalTiny.Body>
                </ModalTiny>
                <ModalTiny show={modalApplyformOpen} onHide={closeApplyformModal} className="modal-form-wrapper people-details-form-modal">
                <ModalTiny.Header>
                <div class="modal-close-btn" onClick={closeApplyformModal}><CloseIcon /></div>
                    <ModalTiny.Title><h4>Send your CV</h4></ModalTiny.Title>
                </ModalTiny.Header>
                <ModalTiny.Body>
                    <CareerForm />
                </ModalTiny.Body>
                </ModalTiny>
            </div>
        </React.Fragment>
    );
};

export default CareerSidebar;